<template>
  <div class="wrap">
    <div class="bannerimg">
      <img src="@/assets/other/profile.jpg" alt="" style="width: 100%" />
    </div>
    <!-- <div class="tab">
      <div class="item-box">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['item', currentIndex == index ? 'active' : '']"
          @click="changeTab(index)"
        >
          {{ item }}
        </div>
      </div>
    </div> -->
    <Nav title="公司简介" />
    <!-- <div class="pagew content" v-if="currentIndex == 0"> -->
      <div class="pagew content" >
      <div class="logo">
        <div class="top-txt">湖南旭麓新材料科技有限公司</div>
        <div class="bottom-txt">Hunan Xulu New Material Technogy Co.,Ltd</div>
      </div>
      <div class="info-content">
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp湖南旭麓新材料科技有限公司成立于2019年，是一家集新型功能材料和元器件技术研发、生产和销售为一体的高科技企业。公司聘请多位国家高层次人才为研发顾问，以硕博人才为主体，与多所985高校建立合作，具备优秀的材料、器件研发能力和广阔的发展前景。
      </div>
      <div class="img-box">
        <div class="item">
          <img src="@/assets/other/9.jpg" alt="" />
          <div class="txt">
            <div class="info">企业合作</div>
            <div class="name">ENTERPRISE COOPERATION</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/other/1.jpg" alt="" />
          <div class="txt">
            <div class="info">高校技术</div>
            <div class="name">UNIVERSITIES IN DISTRICT </div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/other/10.jpg" alt="" />
          <div class="txt">
            <div class="info">设计制造</div>
            <div class="name">DESIGN MANUFACTURE</div>
          </div>
        </div>
      </div>
    </div>

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
import Nav from "../../components/Nav/Nav.vue";
export default {
  name: "workspace",
  components: { Nav },
  data() {
    return {
      list: ["公司简介", "招贤纳士"],
      currentIndex: 0
    };
  },
  methods: {
    changeTab(index) {
      this.currentIndex = index;
      if (this.currentIndex == 1) {
        this.$router.push({ name: "recruitment" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    margin-top: 82px;
  }
  .tab {
    width: 100%;
    height: 50px;
    background-color: #f4f9ff;
    .item-box {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .item {
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
      }
      .active {
        background-color: #5197d5;
        color: #fff;
      }
    }
  }
  .content {
    margin-top: 20px;
    .logo {
      font-weight: bold;
      .top-txt {
        font-size: 30px;
      }
    }

    .info-content {
      padding: 20px 20px 30px 20px;
      line-height: 30px;
      text-align: left;
      font-size: 16px;
    }

    .img-box {
      display: flex;
      justify-content: space-between;
      .item {
        position: relative;
        width: 400px;
        height: 200px;
        img {
          width: 400px;
          height: 200px;
        }

        .txt {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: bold;
          color: rgb(255, 255, 255);

          .name {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/workspace.vue